export class RedirectError extends Error {
  constructor(public readonly redirectTo: string) {
    super(`Redirect to ${redirectTo}`);
    this.name = "RedirectError";
  }
}

export class AuthError extends Error {
  constructor(message = "unauthorized") {
    super(message);
    this.name = "AuthError";
  }
}
